module.exports = __webpack_public_path__ + "img/coca_logo.e64d6c8b.png";